import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ForgotPasswordForm from './ForgotPasswordForm';
import LoginForm from './LoginForm';
import ResetPasswordForm from './ResetPasswordForm';
import AuthenticatedLandingPage from './AuthenticatedLandingPage';
import { dashboardRoute, forgotPasswordRoute, homeRoute, resetPasswordRoute } from '../utils/routes';

export type Props = {
  [key: string]: any;
};

const AuthRoutes: React.FC = () => (
  <Routes>
    <Route path={homeRoute()} element={<LoginForm />} />
    <Route path={dashboardRoute()} element={<AuthenticatedLandingPage />} />
    <Route path={forgotPasswordRoute()} element={<ForgotPasswordForm />} />
    <Route path={resetPasswordRoute()} element={<ResetPasswordForm />} />
  </Routes>
);

export default AuthRoutes;
